<template>
    <el-form-item :class="{getClassByCopy,'hidden':component.properties.sortType==='hidden','to-top':component.properties.sortType==='toTop'}" @mouseenter.stop.native="controlMouseOver(component, index)" @click.native="controlClick(component, index)" :prop="getProp" :rules="rules" :label="component.properties.sortType==='hidden' ? '' : labelParameter.labelName" :title="component.name" :label-width="labelParameter.width" ref="elFormItem">
      <div v-if="labelParameter.showSlot" :class="['control-label', labelParameter.className]" slot="label">{{labelParameter.labelName}}</div>
      <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
        <span class="fa fa-question-circle"></span>
      </el-tooltip>
      <el-input :value="getValue"
                :title="getValue"
                :class="[inputWidth && Number(inputWidth) < 30 && 'clear-padding']"
                :style="{width: inputWidth ? inputWidth + 'px' : '100%', maxWidth: '100%'}"
                @input="idCardInput"
                @change="customChangeEvent"
                :disabled="disabled || component.properties.readonly"
                :placeholder="component.properties.placeholder"
                @focus="inputFocus(component, index)"
                @blur="validateFormItem"></el-input>
    </el-form-item>
</template>

<script>
import { componentMixin, inputMixin, relFunMixin, calculationMixin, defaultValueMixin } from './mixins'
import { getArea } from '@utils'
export default {
  name: 'rc-id-card',
  mixins: [ componentMixin, inputMixin, relFunMixin, calculationMixin, defaultValueMixin ],
  props: {
    component: Object,
    value: {
      default: ''
    },
    disabled: Boolean,
    custParams: Object,
    labelParameter: Object,
    index: [Number, String],
    tableCtrlKey: Boolean
  },
  methods: {
    updateValue (val) {
      this.update(val)
      if (val.length === 15 || val.length === 18) {
        let childrenValue = {
          recognizeAddr: '',
          recognizeBirthday: '',
          recognizeAge: '',
          recognizeSex: ''
        }
        const areaData = getArea()
        childrenValue.recognizeAddr = areaData[val.substr(0, 6)]
        if (val.length === 15) {
          childrenValue.recognizeBirthday = `19${val.substr(6, 2)}-${val.substr(8, 2)}-${val.substr(10, 2)}`
          childrenValue.recognizeAge = getAge(parseInt(`19${val.substr(6, 2)}`), parseInt(val.substr(8, 2)), parseInt(val.substr(10, 2)))
          childrenValue.recognizeSex = parseInt(val.substr(14, 1)) % 2 === 0 ? '女' : '男'
        } else {
          childrenValue.recognizeBirthday = `${val.substr(6, 4)}-${val.substr(10, 2)}-${val.substr(12, 2)}`
          childrenValue.recognizeAge = getAge(parseInt(`${val.substr(6, 4)}`), parseInt(val.substr(10, 2)), parseInt(val.substr(12, 2)))
          childrenValue.recognizeSex = parseInt(val.substr(16, 1)) % 2 === 0 ? '女' : '男'
        }
        // 赋值
        for (let attr in this.component.properties.discriminate) {
          if (this.component.properties.discriminate[attr] && this.component.properties.discriminate[attr] !== '') {
            this.update({value: childrenValue[attr], componentId: this.component.properties.discriminate[attr]})
          }
        }
      }
    },
    // blur
    idCardInput (val) {
      this.updateValue(val)
      // 触发失焦事件
      this.$nextTick(() => this.executeFunctions('change'))
    }
  },
  computed: {
    getValue () {
      return this.custParams && this.custParams.value !== undefined ? this.custParams.value : this.value
    }
  }
}
function getAge (year, month, day) {
  let nowYear = new Date().getFullYear()
  let nowMonth = new Date().getMonth() + 1
  let nowDay = new Date().getDate()
  let age = nowYear - year
  if (month < nowMonth) {
    age -= 1
  } else if (month === nowDay) {
    if (nowDay < day) {
      age -= 1
    }
  }
  return age
}
</script>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-id-card.vue